import {redirect} from "react-router-dom";
import Farms from "../../../services/UkTreatmentApi/Farms";

export async function action({params}) {
    await Farms.delete(params.farmUid);

    return redirect("/manage/farms");
}